export default __webpack_public_path__ + "static/media/support-page-header.7e9ef4ea.svg";